// Footer.js
import React from 'react';
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';
import styled from "styled-components";

function Footer() {
  return (
    <FooterContainer id="contact">
        <SocialLinks aria-label="Social links">
          <SocialLink href="https://www.youtube.com/channel/UCDPPfrCYMXon-KCSRfKymTQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube aria-hidden="true" /></SocialLink>
          <SocialLink href="https://www.instagram.com/kenandbryn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram aria-hidden="true" /></SocialLink>
          <SocialLink href="https://www.tiktok.com/@kenandbryn" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok aria-hidden="true" /></SocialLink>
          <SocialLink href="https://www.facebook.com/kenandbryn/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF aria-hidden="true" /></SocialLink>
        </SocialLinks>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer`
  background-color: #333;
  color: white;
  padding: 15px;
  text-align: center;
`;

const SocialLinks = styled.nav`
  display: flex;
  justify-content: center;
  gap: 34px;
`;

const SocialLink = styled.a`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.65rem;
  text-decoration: none;
  transition: color 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;

  &:hover,
  &:focus-visible {
    color: #f5d28a;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 0 1px rgba(245, 210, 138, 0.28);
    transform: translateY(-2px);
    outline: none;
  }

  @media (max-width: 520px) {
    width: 38px;
    height: 38px;
    font-size: 1.45rem;
  }
`;

export default Footer;
